import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Form, FloatingLabel, Image, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
// import { BedTypeServices } from "../../services/BedType";
import { LoadingModal } from "../components/LoadingModal";
import { RolesService } from "../../services/Roles";
import { DesignationsService } from "../../services/Designations";
import { UsersService } from "../../services/Users";
import { AuthService } from "../../services/AuthService";
import { TalukServices } from "../../services/Taluk";
import { PHCServices } from "../../services/Phcs";
import { AshaBlockServices } from "../../services/AshaBlocks";
import styles from "../../styles/Modal.module.css";
import buttonStyles from "../../styles/Buttons.module.css";
import AlertModal from "../../components/AlertModal";

function EditUsersModal({ show, onHide, user }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [roles, setRoles] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [users, setUsers] = useState({
    id: undefined,
    name: "",
    email: "",
    mobileNo: "",
    roleId: "",
    designationId: "",
    talukId: "",
    phcId: "",
    ashaBlockId: "",
  });
  
  // State for Taluks dropdown
  const [taluks, setTaluks] = useState([]);
const [phcs, setPhcs] = useState([]);
const [ashaBlocks, setAshaBlocks] = useState([]);
  const [selectedTaluk, setSelectedTaluk] = useState("");

  // Alert modal state
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertModalData, setAlertModalData] = useState({ title: '', message: '', type: 'info' });
  const getRoles = async () => {
    try {
      const res = await RolesService.getAllRoles(1, 1000, 1);
      if (res.data?.length > 0) {
        setRoles(res.data);
      } else {
        setRoles([]);
      }
    } catch (error) {}
  };

  const getDesignations = async (roleId) => {
    try {
      const res = await DesignationsService.geDesignationsById(roleId);
      if (res.data?.length > 0) {
        setDesignations(res.data);
      } else {
        setUsers({ ...users, designationId: null });
        setDesignations([]);
      }

    } catch (error) {
      console.error("Error fetching designations:", error);
      setDesignations([]);
    }
  };

  // Check if Taluk role is selected
  const isTalukRole = () => {
    const role = roles.find(r => r.id === users.roleId);
    return role && role.role.toLowerCase() === "taluk";
  };

  const fetchTaluks = async () => {
    try {
      const res = await TalukServices.getAllTaluks();
      setTaluks(Array.isArray(res) ? res : []);
    } catch (error) {
      console.error("Error fetching taluks:", error);
      setTaluks([]);
    }
  };

  // Fetch PHCs by Taluk Id
  const fetchPhcs = async (talukId) => {
    try {
      const res = await PHCServices.gePhcsByTalukId(talukId);
      setPhcs(Array.isArray(res) ? res : []);
    } catch (error) {
      console.error("Error fetching PHCs:", error);
      setPhcs([]);
    }
  };

  // Fetch Asha Blocks by PHC Id
  const fetchAshaBlocks = async (phcId) => {
    try {
      const res = await AshaBlockServices.geAshaBlockByPhcId(phcId);
      setAshaBlocks(Array.isArray(res) ? res : []);
    } catch (error) {
      console.error("Error fetching Asha Blocks:", error);
      setAshaBlocks([]);
    }
  };

  useEffect(() => {
    if (user?.id) {
      fetchTaluks();

      setUsers({
        id: user.id,
        name: user.name || "",
        email: user.email || "",
        mobileNo: user.mobileNo || "",
        roleId: user.roleDetails?.id || "",
        designationId: user.designationDetails?.id || "",
      });
      if (user.roleDetails?.id) {
        getDesignations(user.roleDetails.id);
      }
      if (user.roleDetails?.role === "Taluk") {
        setUsers(prev => ({
          ...prev,
          talukId: user.talukDetails?.id || ""
        }));
        setSelectedTaluk(user.talukDetails || "");
      }

      if (user.roleDetails?.role === "PHC") {
        const talukId = user.phcDetails?.talukDetails?.id;
        if (talukId) {
          fetchPhcs(talukId);
          setUsers(prev => ({
            ...prev,
            talukId,
            phcId: user.phcDetails?.id || ""
          }));
          setSelectedTaluk(user.phcDetails?.talukDetails || "");
        }
      }

      if (user.roleDetails?.role === "Asha Block") {
        const talukId = user.ashaBlockDetails?.phcDetails?.talukDetails?.id;
        const phcId = user.ashaBlockDetails?.phcDetails?.id;
        if (talukId) fetchPhcs(talukId);
        if (phcId) fetchAshaBlocks(phcId);
        setUsers(prev => ({
          ...prev,
          talukId,
          phcId,
          ashaBlockId: user.ashaBlockDetails?.id || ""
        }));
        setSelectedTaluk(user.ashaBlockDetails?.phcDetails?.talukDetails || "");
      }
    }
  }, [user]);

  const handleTalukChange = (e) => {
    const talukId = Number(e.target.value);
    setUsers(prev => ({ ...prev, talukId, phcId: "", ashaBlockId: "" }));

    if (users.roleId === 3) {
      fetchPhcs(talukId);
    }
  };

  const handlePhcChange = (e) => {
    const phcId = Number(e.target.value);
    setUsers(prev => ({ ...prev, phcId, ashaBlockId: "" }));

    if (users.roleId === 4) {
      fetchAshaBlocks(phcId);
    }
  };

  const handleAshaBlockChange = (e) => {
    const ashaBlockId = Number(e.target.value);
    setUsers(prev => ({ ...prev, ashaBlockId }));
  };

  useEffect(() => {
    getRoles();
    fetchTaluks();
  }, []);

  const [error, setError] = useState({
    name: "",
    email: "",
    mobileNo: "",
    role: "",
    designation: "",
  });

  const validation = () => {
    let tempError = {
      name: "",
      email: "",
      mobileNo: "",
      role: "",
      designation: "",
    };
    let valid = true;
    if (!users.name) {
      tempError.name = "Name is required";
      valid = false;
    }
    if (!users.mobileNo || !users.mobileNo.match(/^\d{10}$/)) {
      tempError.mobileNo =
        "Mobile number is required and must contain 10 digits";
      valid = false;
    }
    if (
      !users.email ||
      !users.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
    ) {
      tempError.email = "Email is required or Email is not valid";
      valid = false;
    }
    if (!users.roleId) {
      tempError.role = "Role is required";
      valid = false;
    }
    if (!users.designationId) {
      tempError.designation = "Designation is required";
      valid = false;
    }

    // Validate taluk if role is Taluk
    if (isTalukRole() && !users.talukId) {
      tempError.talukId = "Taluk is required for Taluk role";
      valid = false;
    }

    setError(tempError);
    return valid;
  };

  const update = async () => {
    if (validation()) {
      setLoading(true);
      try {
        let payload = { ...users };
        const roleName = user.roleDetails?.role;
  
        if (roleName === "PHC") {
          payload.talukId= "";
          payload.ashaBlockId= "";
        }
  
        if (roleName === "Taluk") {
          payload.phcId= "";
          payload.ashaBlockId= "";
        }
  
        if (roleName === "Asha Block") {
          payload.talukId= "";
          payload.phcId= "";
        }
        console.log(payload);
        const res = await UsersService.updateUsers(payload);
        if (res.status === 200) {
          setAlertModalData({
            title: "Success",
            message: res.message || "User updated successfully!",
            type: "success"
          });
          setShowAlertModal(true);
          onHide();
          navigate("/users");
        } else {
          setAlertModalData({
            title: "Error",
            message: "Error while updating user",
            type: "error"
          });
          setShowAlertModal(true);
        }
        setLoading(false);
      } catch (error) {
        setAlertModalData({
          title: "Error",
          message: error.message || "Failed to update user",
          type: "error"
        });
        setShowAlertModal(true);
        setLoading(false);
      }
    }
  };


  useEffect(() => {
    if (show && users.roleId) {
      getDesignations(users.roleId);
    }
  }, [show, users.roleId]);


  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        className={styles.modal}
      >
        <Form onSubmit={(e) => { e.preventDefault(); update(); }} className={styles.modalForm}>
          <Modal.Header closeButton className={styles.modalHeader}>
            <Modal.Title className={styles.modalTitle}>Edit User</Modal.Title>
          </Modal.Header>
  
          <Modal.Body className={styles.modalBody}>
            <Row className="mb-3">
              <Col md={6}>
                <FloatingLabel controlId="editName" label="Name*">
                  <Form.Control
                    type="text"
                    value={users.name}
                    onChange={(e) => setUsers({ ...users, name: e.target.value })}
                    isInvalid={!!error.name}
                    required
                  />
                  <div className="invalid-feedback">{error.name}</div>
                </FloatingLabel>
              </Col>
              <Col md={6}>
                <FloatingLabel controlId="editMobNo" label="Mob no*">
                  <Form.Control
                    type="text"
                    value={users.mobileNo}
                    onChange={(e) => setUsers({ ...users, mobileNo: e.target.value })}
                    isInvalid={!!error.mobileNo}
                    required
                  />
                  <div className="invalid-feedback">{error.mobileNo}</div>
                </FloatingLabel>
              </Col>
            </Row>
  
            <Row className="mb-3">
              <Col md={6}>
                <FloatingLabel controlId="email" label="Email*">
                  <Form.Control
                    type="email"
                    value={users.email}
                    onChange={(e) => setUsers({ ...users, email: e.target.value })}
                    isInvalid={!!error.email}
                    required
                  />
                  <div className="invalid-feedback">{error.email}</div>
                </FloatingLabel>
              </Col>
            </Row>
  
            {/* <Row className="mb-3">
              <Col md={6}>
                <FloatingLabel controlId="role" label="Role*">
                  <Form.Select
                    value={users.roleId}
                    disabled
                    isInvalid={!!error.role}
                    required
                  >
                    <option value="">Select Role</option>
                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>{role.role}</option>
                    ))}
                  </Form.Select>
                  <div className="invalid-feedback">{error.role}</div>
                </FloatingLabel>
              </Col>
              <Col md={6}>
                <FloatingLabel controlId="designation" label="Designation*">
                  <Form.Select
                    value={users.designationId}
                    onChange={(e) => setUsers({ ...users, designationId: Number(e.target.value) })}
                    isInvalid={!!error.designation}
                    required
                    disabled
                  >
                    <option value="">Select Designation</option>
                    {designations.map((d) => (
                      <option key={d.id} value={d.id}>{d.designation}</option>
                    ))}
                  </Form.Select>
                  <div className="invalid-feedback">{error.designation}</div>
                </FloatingLabel>
              </Col>
            </Row> */}
            <Row className="mb-3">
  <Col md={6}>
    <FloatingLabel controlId="role" label="Role">
      <Form.Control
        type="text"
        value={roles.find(r => r.id === users.roleId)?.role || ""}
        readOnly
        plaintext 
      />
    </FloatingLabel>
  </Col>

  <Col md={6}>
    <FloatingLabel controlId="designation" label="Designation">
      <Form.Control
        type="text"
        value={designations.find(d => d.id === users.designationId)?.designation || ""}
        readOnly
        plaintext 
      />
    </FloatingLabel>
  </Col>
</Row>

            {user?.roleDetails?.role === "Taluk" && (
  <Row className="mb-3">
    <Col md={6}>
      <FloatingLabel controlId="taluk" label="Taluk*">
        <Form.Select
          value={users.talukId || ""}
          onChange={handleTalukChange}
          isInvalid={!!error.talukId}
          required
        >
          <option value="">Select Taluk</option>
          {taluks.map((t) => (
            <option key={t.id} value={t.id}>
              {t.taluk}
            </option>
          ))}
        </Form.Select>
        <div className="invalid-feedback">{error.talukId}</div>
      </FloatingLabel>
    </Col>
  </Row>
)}

{user?.roleDetails?.role === "PHC" && (
  <Row className="mb-3">
    <Col md={6}>
      <FloatingLabel controlId="taluk" label="Taluk*">
        <Form.Select
          value={users.talukId || ""}
          onChange={handleTalukChange}
          isInvalid={!!error.talukId}
          required
        >
          <option value="">Select Taluk</option>
          {taluks.map((t) => (
            <option key={t.id} value={t.id}>
              {t.taluk}
            </option>
          ))}
        </Form.Select>
        <div className="invalid-feedback">{error.talukId}</div>
      </FloatingLabel>
    </Col>
    <Col md={6}>
      <FloatingLabel controlId="phc" label="PHC*">
        <Form.Select
          value={users.phcId || ""}
          onChange={handlePhcChange}
          isInvalid={!!error.phcId}
          required
        >
          <option value="">Select PHC</option>
          {phcs.map((p) => (
            <option key={p.id} value={p.id}>
              {p.phc}
            </option>
          ))}
        </Form.Select>
        <div className="invalid-feedback">{error.phcId}</div>
      </FloatingLabel>
    </Col>
  </Row>
)}

{user?.roleDetails?.role === "Asha Block" && (
  <Row className="mb-3">
    <Col md={4}>
      <FloatingLabel controlId="taluk" label="Taluk*">
        <Form.Select
          value={users.talukId || ""}
          onChange={handleTalukChange}
          isInvalid={!!error.talukId}
          required
        >
          <option value="">Select Taluk</option>
          {taluks.map((t) => (
            <option key={t.id} value={t.id}>
              {t.taluk}
            </option>
          ))}
        </Form.Select>
        <div className="invalid-feedback">{error.talukId}</div>
      </FloatingLabel>
    </Col>
    <Col md={4}>
      <FloatingLabel controlId="phc" label="PHC*">
        <Form.Select
          value={users.phcId || ""}
          onChange={handlePhcChange}
          isInvalid={!!error.phcId}
          required
        >
          <option value="">Select PHC</option>
          {phcs.map((p) => (
            <option key={p.id} value={p.id}>
              {p.phc}
            </option>
          ))}
        </Form.Select>
        <div className="invalid-feedback">{error.phcId}</div>
      </FloatingLabel>
    </Col>
    <Col md={4}>
      <FloatingLabel controlId="ashaBlock" label="Asha Block*">
        <Form.Select
          value={users.ashaBlockId || ""}
          onChange={handleAshaBlockChange}
          isInvalid={!!error.ashaBlockId}
          required
        >
          <option value="">Select Asha Block</option>
          {ashaBlocks.map((a) => (
            <option key={a.id} value={a.id}>
              {a.ashaBlock}
            </option>
          ))}
        </Form.Select>
        <div className="invalid-feedback">{error.ashaBlockId}</div>
      </FloatingLabel>
    </Col>
  </Row>
)}
          </Modal.Body>
  
          <Modal.Footer className={styles.modalFooter}>
            {AuthService.canUpdate() && (
              <Button type="submit" variant="success" className={buttonStyles.primaryButton}>
                Update
              </Button>
            )}
            <Button variant="danger" onClick={onHide} className={buttonStyles.dangerButton}>
              Cancel
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
  
      {/* Alert Modal */}
      <AlertModal
        show={showAlertModal}
        title={alertModalData.title}
        message={alertModalData.message}
        type={alertModalData.type}
        onClose={() => setShowAlertModal(false)}
      />
    </>
  );
  
}

function EditUsers(props) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <FontAwesomeIcon
        icon={faEdit}
        size="lg"
        style={{ color: '#05275a' }}
        className="action-icon edit-icon"
        onClick={() => setModalShow(true)}
        title="Edit User"
      />
      {modalShow && (
        <EditUsersModal
          show={modalShow}
          onClick={props.onHide}
          onHide={() => {
            setModalShow(false);
            props.onClose();
          }}
          user={props.user}
        />
      )}
    </>
  );
}

export default EditUsers;
